import type { Nullable } from '@iheartjane/types';

import { cartSize } from '@jane/shared-ecomm/util';

import type { CartWeightInput } from './getProductWeightInCart';

export const getProductWeightUnitInCart = (
  cart?: Nullable<CartWeightInput>
) => {
  if (!cart || cartSize(cart) === 0) {
    return null;
  }

  for (const p of cart.products ?? []) {
    if (p.kind === 'flower') {
      return 'g';
    }
  }

  return null;
};
